module.exports = "@media screen and (max-width: 991px) {\n  .table {\n    width: 800px;\n    overflow-x: visible; } }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/dynamic-table/dynamic-table.component.scss
// module id = ./web/modern/components/settings/common/dynamic-table/dynamic-table.component.scss
// module chunks = 0